// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3wzVx","title":"InfoRow_title__1Unib"};